$(function() {
  $('.lazy').lazy();
});

$(document).ready(function(){
  var winW = $(window).width();

	// Header
  var barraH = $('.bar-mes').outerHeight();
  var infoH = $('.barra').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function(){
    var barraH = $('.bar-mes').outerHeight();
    var infoH = $('.barra').outerHeight();
    var headerH = $('header').outerHeight();
  });

  if ( winW > 830 ) {
    $('body').css('padding-top', barraH + infoH + headerH);
    $('header').css('top', barraH + infoH);
    $('.barra').css('top', barraH);
    $(window).load(function(){
      $('body').css('padding-top', barraH + infoH + headerH);
      $('header').css('top', barraH + infoH);
      $('.barra').css('top', barraH);
    });
    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH + infoH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH + infoH);
      }
    });
  } else {
    var padTop = barraH + headerH;
    $('body').css('padding-top', padTop);
    $('header').css('top', barraH);
    $(window).scroll(function(){
      if ($(window).scrollTop() > barraH) {
        $('header').addClass('fix');
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH);
      }
    });
  }

	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
	});

  $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
	});

	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');
	});

	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');
	});

	$('header .show-menu').click(function(){
		$('nav').addClass('show');
	});

	$('nav .top .cerrar').click(function(){
		$('nav').removeClass('show');
	});

	// Product

  $('.product .des-wrap > h3').each(function(){
    $(this).addClass('langh3');
    $(this).nextUntil('h3').wrapAll('<div class="lang"></div>')
  })

  $('.product .des-wrap .lang:nth-of-type(1)').addClass('lang-es');
  $('.product .des-wrap .lang:nth-of-type(2)').addClass('lang-en');

  $('.product .deon > h3').each(function(){
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  })

  $('.product .deon h3').click(function(){
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.featured-collection ul .item[data-id="5125822054535"]').remove();
  $('.featured-collection ul .item[data-id="5125823266951"]').remove();

  // Pop Up
  $('#popup .cerrar').click(function(){
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  /**
  * Escucha permanente para agregar productos, funciona para snippet
  * product-item.liquid
  *
  * @param object this  Contiene el objeto del elemento cliqueado.
  */
  $('body').on('click', '.item .addcart', function() {
    var proVar = $(this).data('product-id');
    var proQt = $(this).siblings('.sec-cantidad').children().children('input').val();
    if (proQt == undefined) {
        var newQt = 1;
    } else {
      var newQt = parseInt(proQt);
    }
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: newQt,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });

  var userLang = navigator.language || navigator.userLanguage;
  console.log("The language is: " + userLang);

  if ( userLang.toLowerCase().includes('es-') || userLang.toLowerCase() == 'es') {
    $('.lang-en').hide(1);
    $( ".lang-en" ).remove();
  } else {
    $('.lang-es').hide(1);
    $( ".lang-es" ).remove();
  }
});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Qt: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}
